import React from "react";
import { Grid } from "@mui/material";
import EditTable from "../../../components/Components/MaterialReturnableTable";
import { useQuery } from "react-query";
import { getMaterialReturnalableList } from "../mutations/TransactionsMutation";

function MaterialInward() {
  const currentTimestamp = Date.now();

  const currentDate = new Date(currentTimestamp);

  const formattedDate = currentDate.toISOString().slice(0, 10);

  const { data: materialReturnableData } = useQuery(
    "material-returnable-transactions",
    () => getMaterialReturnalableList(formattedDate),
    { refetchOnMount: true }
  );

  console.log({ materialReturnableData });

  return (
    <Grid container justifyContent={"center"}>
      <Grid item textAlign={"center"}>
        <h4>Material Returnable Transactions</h4>
      </Grid>
      <Grid item xs={12}>
        <EditTable tableData={materialReturnableData ?? []} />
      </Grid>
    </Grid>
  );
}

export default MaterialInward;
